import { VendorInventoryCountDetailPage } from "@/features/vendor-app/pages/VendorInventoryCountDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorInventoryCountDetailSearch = {
	inventoryCountTransactionID: string;
};

const str = (v: unknown): string => (typeof v === "string" ? v : "");

export const Route = createFileRoute("/vendor/inventory-count/$productID")({
	validateSearch: (
		search: Record<string, unknown>,
	): VendorInventoryCountDetailSearch => ({
		inventoryCountTransactionID: str(search.inventoryCountTransactionID),
	}),
	component: VendorInventoryCountDetailPage,
});
